// packages/frontend/core/src/modules/theme/theme-config.ts
export interface ThemeConfig {
  id: string;
  name: string;
  colors: {
    backgroundColor: string;

    // 其他颜色...
  };
}

export const THEME_PRESETS: ThemeConfig[] = [
  {
    id: 'light',
    name: 'Light',
    colors: {
      backgroundColor: 'rgba(247,244,239,1)',
    },
  },
  {
    id: 'dark',
    name: 'Dark',
    colors: {
      backgroundColor: 'rgba(17,24,39,1)',
    },
  },
  {
    id: 'blue',
    name: 'Blue',
    colors: {
      backgroundColor: 'rgba(239,246,255,1)',
    },
  },
  {
    id: 'green',
    name: 'Green',
    colors: {
      backgroundColor: 'rgba(240,253,244,1)',
    },
  },
];
